
import React, { useState, useEffect } from 'react'

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';

export default function SurveyHidden(props) {
  const dispatch = useDispatch();
  const [question, setQuestion] = useState(props.question);

  useEffect(()=>{
    const payload = {
      id: question.id,
      answerList: [
          {
              questionOptionId: question?.optionList[0]?.id,
              answerDescription: question?.optionList[0]?.name ? question.optionList[0].name : '',
          }
      ]
    };
  
    console.log(payload);
    dispatch(setQuestionAnswerList(payload));
  },[])

  return (
    <>
      <input type='hidden' id={"question-id-" + question.id + "-option-id-" + question.optionList[0]?.id} class={"question-id-" + question.id + "-option-id-" + question.optionList[0]?.id} name={"questionList[" + question.questionSequenceNo + "].answerList[0].questionOptionId"} value={question.optionList[0].id} />
      
      <input type='hidden' id={"question-id-" + question.id + "-option-id-" + question.optionList[0]?.id + "-answerDescription"} class={"question-id-" + question.id + "-option-id-" + question.optionList[0]?.id + "-answerDescription"} name={"questionList[" + question.questionSequenceNo + "].answerList[0].answerDescription"} value={question?.optionList[0]?.name ? question.optionList[0].name : ''} />
    </>
  )
}
